import Vue from 'vue'
import { Component, Prop, Watch,  } from 'vue-property-decorator';
import menues, { MenuInfo } from './menu'
import * as types from '@/store/types'
import { mapGetters, mapMutations } from 'vuex';
@Component({
    methods: {
        ...mapMutations({
            setCurrentMenu: types.CURRENT_MENU,
            setShowSidebar: types.SIDEBAR_VISIBLE
        })
    },
    computed: {
        ...mapGetters({
            currentMenu: types.CURRENT_MENU
        })
    }
})
export default class MenuItem extends Vue {
    @Prop({ type: Object }) item!: MenuInfo

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: M U T A T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    setCurrentMenu!: (name: string) => void
    setShowSidebar!: (show: boolean) => void

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    currentMenu!: string

    selected: boolean = false

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: C O M P U T E D : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    get menues(): MenuInfo[] {
        return menues
    }

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    menuSelect() {
        const { type, path, name } = this.item
        if (typeof path === 'object') {
            this.$router.push(path)
            this.setShowSidebar(false)
        } else {
            //await(window as any).alertAsync(typeof path)
        }

        this.menues.forEach(x => x.select = false)
        this.item.select = true
        this.setCurrentMenu(name)
    }

    setMenuSelect() {
        var route = this.$route.name ? this.$route.name : ''
        if (this.item.route.includes(route)) {
            this.item.select = true
            this.setCurrentMenu(this.item.name)
        } else {
            this.item.select = false
        }
        this.selected = this.item.select
    }

    @Watch('currentMenu')
    onChangeSelectValue() {
        this.selected = this.item.select
    }

    @Watch('$route.name')
    onChangeRouteValue(newValue: any) {
        this.setMenuSelect()
    }

    created() {
        this.setMenuSelect()
    }
}